//import './Thumbnail.scss';

import PropTypes from 'prop-types';
import React from 'react';

const Thumbnail = ({ className, imageUrl }) => {
  if (!imageUrl) return null;
  return (
    <div>
      <img
        src={imageUrl}
        alt="..."
        className={`img-thumbnail-table rounded ${className}`}
      />
    </div>
  );
};

Thumbnail.propTypes = {
  className: PropTypes.string,
  imageUrl: PropTypes.string,
};

export { Thumbnail };
